const API = '/api';
import React, { createContext, useState, useContext, useEffect, useRef } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const activeContextRef = useRef('landing');

  const [theme, setThemeState] = useState(() => {
    const saved = localStorage.getItem('theme-landing');
    return saved || 'dark';
  });

  useEffect(() => {
    const root = window.document.documentElement;
    root.classList.remove('light', 'dark');
    root.classList.add(theme);
  }, [theme]);

  const setThemeForContext = (context) => {
    const key = context === 'dashboard' ? 'theme-dashboard' : 'theme-landing';
    const def = context === 'dashboard' ? 'light' : 'dark';
    activeContextRef.current = context;
    const saved = localStorage.getItem(key);
    const resolved = saved || def;
    if (!saved) localStorage.setItem(key, resolved);
    setThemeState(resolved);
  };

  const toggleTheme = () => {
    setThemeState(prev => {
      const next = prev === 'light' ? 'dark' : 'light';
      const key = activeContextRef.current === 'dashboard' ? 'theme-dashboard' : 'theme-landing';
      localStorage.setItem(key, next);
      return next;
    });
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, setThemeForContext }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
};